import React from 'react';
import styles from './BasicLoader.module.css';

export const BasicLoader = () => {
    const bricks = Array.from({ length: 6 });

    return (
        <ul className={styles.loaderContainer}>
            {bricks.map((_, index) => (
                <li key={index} className={styles[`brick${index + 1}`]} />
            ))}
        </ul>
    );
};
